import type { RegistryIconProps } from '../registry';

// Hand-drawn — no Phosphor glyph reads as an inbox tray from this angle.
export function EmptyInboxIcon({ className, color = 'currentColor', ...props }: RegistryIconProps) {
  return (
    // `fill="none"` on the root only — every child inherits it.
    <svg
      viewBox="0 0 80 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden={props['aria-hidden']}
    >
      <path
        d="M8 46 L8 62 Q8 66 12 66 L68 66 Q72 66 72 62 L72 46"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M8 46 L20 24 Q21.5 21 25 21 L55 21 Q58.5 21 60 24 L72 46"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M26 46 Q28 38 40 38 Q52 38 54 46"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <line x1="8" y1="46" x2="26" y2="46" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      <line
        x1="54"
        y1="46"
        x2="72"
        y2="46"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
